import { getTranslation } from '@/lib/utils/i18n';

// Status label, Badge variants and filter options, built from one domain's status map.

/** @param labelKeys status code → i18n label key */
export const createStatusOptions = (labelKeys) => {
  // For non-React callers (the mapper); null when unmapped so it can fall back.
  const statusLabel = (status) => {
    const key = labelKeys[status];
    return key ? getTranslation(key) : null;
  };

  // Cells key variantMap by the RENDERED value, so build it from the same labels.
  const buildStatusVariants = (t, variants) =>
    Object.fromEntries(
      Object.entries(labelKeys).map(([status, key]) => [t(key), variants[status]]),
    );

  // `only` narrows the panel to the states the query's enum accepts; one it rejects errors it.
  const buildStatusFilterOptions = (t, only) =>
    Object.entries(labelKeys)
      .filter(([status]) => !only || only.includes(status))
      .map(([status, key]) => ({ value: status, label: t(key) }));

  return { statusLabel, buildStatusVariants, buildStatusFilterOptions };
};
